import { useEffect, useRef, useState } from "react";
import './in-use-clients.styles.scss';

const InUseClientsTooltip = ({ 
  children, 
  clients, 
  header, 
  disabled,
  itemRender = (item) => {}
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const anchorRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  useEffect(() => {
    if (isHovered && anchorRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      setMenuPosition({ top: rect.bottom, left: rect.left });
      hoverTimeoutRef.current = setTimeout(() => {
        setShowTooltip(true);
      }, 300);
    } else {
      clearTimeout(hoverTimeoutRef.current);
      setShowTooltip(false);
    }
  }, [isHovered]);

  return (
    <div 
      className='in-use-clients-tooltip' 
      onMouseLeave={() => setIsHovered(false)}
    >
      <div 
        className='d-flex align-items-center anchor'
        onMouseEnter={() => setIsHovered(true)}
        ref={anchorRef}
      >
        {children}
      </div>
      {(!disabled && showTooltip) && (
        <div 
          className='menu hide-scrollbar'
          style={{ position: 'fixed', top: `${menuPosition.top}px`, left: `${menuPosition.left}px` }}
        >
          <h3 className="m-0 title f-darkgrey">
            {header}
          </h3>
          <div className="list">
            {clients.map((client, index) => (
              itemRender(client)
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default InUseClientsTooltip;